import React, { useEffect, useState } from 'react';
import './styles.scss';
import { UncontrolledTooltip } from 'reactstrap';

const CustomRadioButton = ({ options, onPress, value, className, valueField, displayField, isEditable = true }) => {
  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    setSelectedValue(value);
  }, [value, isEditable]);

  const handleChange = (clickedValue, index) => {
    setSelectedValue(clickedValue);
    onPress(clickedValue, index);
  };

  return (
    <div
      className={`btn-group ${className || ''}`}
      role="group"
      style={{ pointerEvents: isEditable ? 'auto' : 'none' }}
    >
      {options.map((item, index) => (
        <>
          <button
            onClick={() => handleChange(item[valueField], index)}
            id={`custom-radio-button-${item[valueField]}`}
            key={index}
            type="button"
            className={`btn ${item[valueField] === selectedValue ? 'active' : ''}`}
            disabled={item.disabled || !isEditable}
          >
            {item[displayField]}
          </button>
          {item && item.tooltip && (
            <UncontrolledTooltip placement="bottom" target={`custom-radio-button-${item[valueField]}`}>
              {item.tooltip}
            </UncontrolledTooltip>
          )}
        </>
      ))}
    </div>
  );
};

export default CustomRadioButton;
